import React from 'react';
import AccountConcept from 'components/Tvendo/Shopping/DataMaster/Account/AccountConcept/AccountConcept.js';

export default function () {
  return <AccountConcept />;
}
